import { useEffect, useState } from 'react'
import '../css/toast.css'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'

export const Toast = ({ texto }) => {

    const mostrar = useEmpleadoStore( state => state.toast )
    const setToast = useEmpleadoStore( state => state.setToast )

    const [clase, setClase] = useState("")

    useEffect(() => {

        if ( mostrar ) {
            setClase("show")

            setTimeout(() => {

                setClase("")
                setToast(false)

            }, 3000);
        }

        // eslint-disable-next-line
    }, [mostrar])

    return (
        <div className='d-flex justify-content-center'>
            <div id="toast" className={ clase }>{ texto }</div>
        </div>
    )
}
